import {combineEpics} from "redux-observable";
import {loadDataOfCourse, loadDataTraining} from "./epics/corso-load.epics";
import {
    getCalendarioPianificazioneRicerca,
    initCalendario,
    pianificazioniCalendarioCreate
} from './epics/pianificazioni-calendario.epics'
import {removeValidations, recoveryDatiRegistro, initResocontoMese} from "./epics/registro.epics";
import {timbraturaManuali, recuperaTimbrature} from "./epics/timbrature.epics";
import {giustificativiManuali} from "./epics/giustificativi.epics";
import {startLoading} from "./epics/loading.epics";

export const rootEpic = combineEpics(
    startLoading,
    timbraturaManuali,
    giustificativiManuali,
    recuperaTimbrature,
    initResocontoMese,
    removeValidations,
    recoveryDatiRegistro,
    loadDataOfCourse,
    loadDataTraining,
    initCalendario,
    pianificazioniCalendarioCreate,
    getCalendarioPianificazioneRicerca
);
